import { Injectable } from '@angular/core';
import { ApiDataService } from '@core/services/api/api-data.service';


@Injectable({
  providedIn: 'root'
})
export class ApiExhibitionsService extends ApiDataService {
  apiUrl = 'client/exhibitions';
}
